<!--车辆位置-->
<template>
    <div class="carPosition">
        <van-nav-bar
            title="车辆位置"
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <div class="container">
            <BaiduMap
                class="map"
                ref="map"
                :center="marker.position"
                :zoom="zoom"
                ak="8oGi1YBeLNnGA54yA1YuyumkzjjfGqmW"
            >
                <bm-marker
                    :position="marker.position"
                    :icon="marker.icon"
                >
                </bm-marker>
            </BaiduMap>
            <div class="getCurrentPosition" @click="getCurrentPosition">
                <span class="iconfont icondingwei"></span>
            </div>
        </div>
    </div>
</template>

<script>
import BaiduMap from 'vue-baidu-map-v3/components/map/Map.vue';
import BmMarker from 'vue-baidu-map-v3/components/overlays/Marker.vue';
import { HeaderNav } from '@/views/map/locationInfo';
export default {
    name: 'car-position',
    components: {
        BaiduMap,
        BmMarker,
    },
    data() {
        return {
            zoom: 14,
            marker: {
                position: { lng: 116.397428, lat: 39.90923 },
                icon: {
                    url: require('@/assets/images/home_kh/vehicle_home.png'),
                    size: { width: 110, height: 110 },
                },
            },
        };
    },
    created() {
        window.jyCallback_DriverUntieVehicle = this.jyCallback_DriverUntieVehicle;
        if (this.$route.query.longlat) {
            const pos = this.$route.query.longlat.split(',');
            this.marker.position = { lng: pos[0], lat: pos[1] };
        }
    },
    methods: {
        // 返回上级页面
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 获取当前定位
        getCurrentPosition() {
            this.$callMobile('JYExternalNative', 'jyDriverUntieVehicleEvent');
        },
        // 获取原生定位后回调
        jyCallback_DriverUntieVehicle(data) {
            const dataParse = JSON.parse(data);
            this.center = { lng: dataParse.longitude, lat: dataParse.latitude };
        },
    },
};
</script>

<style lang="stylus" scoped>
.carPosition
    height 100%
    .container
        height calc(100% - 44rpx)
        position relative
        .el-vue-search-box-container
            margin 10rpx
            width calc(100% - 20rpx)
            height 40rpx
            position absolute
            .search-box-wrapper
                border-radius 4px
                overflow hidden
                .search-btn
                    background #0189FC
                    color #fff
                input
                    padding 0 10rpx 0 0
            .search-tips
                width 100%
        .map
            height 100%
        .btn-con
            position absolute
            bottom 40rpx
            width 100%
            text-align center
            .btn
                background #D6010F
                border-radius 20rpx
                padding 10rpx 80rpx
                color #fff
        .getCurrentPosition
            position absolute
            bottom 30rpx
            left 10rpx
            width 30rpx
            height 30rpx
            background #fff
            border 1px solid #ccc
            box-shadow 1px 1px 10px 0 #ccc
            text-align center
            line-height 28rpx
            border-radius 3rpx
            &:hover
                color #5588F1
</style>
